module.exports = __webpack_public_path__ + "static/edu-9121292ef984c0b427f62e40377f7ab4.png";